module.exports = __webpack_public_path__ + "img/mp.mp669fb6a.svg";